import React from 'react';
import styled from 'styled-components';
import { globalFormat } from '../../../../../utils/formatting';
import useBrowserTimezoneLabel from '../../../../../utils/hooks/useBrowserTimezoneLabel';
import { theme } from '../../../../../styles/theme';

interface IProps {
  refreshedAt: string;
}

const Container = styled.span`
  font-size: 10px;
  font-weight: 400;
  color: ${theme.colors.secondary600};
`;

const DashboardRefreshInfo = ({ refreshedAt }: IProps) => {
  const { dateFormat, timeFormat } = globalFormat.getGlobalFormat();
  const browserTimeZoneLabel = useBrowserTimezoneLabel();

  return (
    <Container>
      {' - '}Refreshed on{' '}
      {globalFormat.formatDate(refreshedAt, {
        dateFormat,
        timeFormat,
      })}{' '}
      {browserTimeZoneLabel}
    </Container>
  );
};

export default DashboardRefreshInfo;
